// extracted by mini-css-extract-plugin
export default {"order":"Order_order__nSlFb","currentOrder":"Order_currentOrder__XpAjF"};